export const encodeEmail = (email: string): string => {
    if (isEmailEncoded(email)) {
        return email;
    }
    return encodeURIComponent(email).replaceAll(".", "%2E");
}

export const isEmailEncoded = (email: string): boolean => {
    return email.includes("%2E");
}

export const decodeEmail = (email: string): string => {
    if (!isEmailEncoded(email)) {
        return email;
    }
    return decodeURIComponent(email.replaceAll("%2E", "."));
}